'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dProduct11 from "./scala.-Product11.js";
var $p;
/** @constructor */
function $c_T11(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11) {
  this.my = null;
  this.mB = null;
  this.mC = null;
  this.mD = null;
  this.mE = null;
  this.mF = null;
  this.mG = null;
  this.mH = null;
  this.mI = null;
  this.mz = null;
  this.mA = null;
  this.my = _1;
  this.mB = _2;
  this.mC = _3;
  this.mD = _4;
  this.mE = _5;
  this.mF = _6;
  this.mG = _7;
  this.mH = _8;
  this.mI = _9;
  this.mz = _10;
  this.mA = _11;
}
export { $c_T11 as $c_T11 };
$p = $c_T11.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_T11;
/** @constructor */
function $h_T11() {
}
export { $h_T11 as $h_T11 };
$h_T11.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.n = (function() {
  return 11;
});
$p.g = (function(n) {
  return $j_scala$002e$002dProduct11.$f_s_Product11__productElement__I__O(this, n);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, 838406606, true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_T11) && (((((((((($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.my, x$0.my) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mB, x$0.mB)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mC, x$0.mC)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mD, x$0.mD)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mE, x$0.mE)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mF, x$0.mF)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mG, x$0.mG)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mH, x$0.mH)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mI, x$0.mI)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mz, x$0.mz)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mA, x$0.mA))));
});
$p.o = (function() {
  return "Tuple11";
});
$p.b = (function() {
  return (((((((((((((((((((((("(" + this.my) + ",") + this.mB) + ",") + this.mC) + ",") + this.mD) + ",") + this.mE) + ",") + this.mF) + ",") + this.mG) + ",") + this.mH) + ",") + this.mI) + ",") + this.mz) + ",") + this.mA) + ")");
});
function $isArrayOf_T11(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eA)));
}
export { $isArrayOf_T11 as $isArrayOf_T11 };
var $d_T11 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_T11, "scala.Tuple11", ({
  eA: 1,
  b: 1,
  c: 1,
  rJ: 1,
  a: 1
}));
export { $d_T11 as $d_T11 };
